module.exports = __webpack_public_path__ + "img/GAME_AIRPLANE1.3a587b38.jpg";